import React from 'react';
import getConfig from '../../config';

// const version = config('version');

const VersionToast = () => {
    const version = getConfig('version') || '';
    return (
        <div role="dialog">
            <img
                alt={version}
                src={`https://img.shields.io/badge/Version-${version.replace(
                    /-/g,
                    ' '
                )}-brightgreen.svg?style=flat`}
            />
        </div>
    );
};

export default VersionToast;
